
/* =======================================
Cross-sell Image Quality Enhancer
======================================= */
function updateCrossSellImageQuality(images) {
  images.forEach((img) => {
    const src = img.getAttribute('src');
    if (!src) return;

    const cleanSrc = src.split('?')[0] + '?width=768';
    img.setAttribute('src', cleanSrc);
    if (img.hasAttribute('srcset')) {
      img.setAttribute('srcset', cleanSrc);
    }
  });
}

function updateAttributes(sliders) {
  sliders.forEach(slider => {
    slider.removeAttribute('aria-hidden');
  })
}

function updateTitleName(el) {
  const linkTitles = el.querySelectorAll('a[data-essential-upsell-element="title"]:not(.is-updated)');

  if(!linkTitles.length) return;

  linkTitles.forEach((linkTitle) => {
    const href = linkTitle.getAttribute('href');

    if (!href) return;

    const slug = href.split('/').filter(Boolean).pop();

    if (!slug) return;

    const hiddenElm = document.createElement('span');
    hiddenElm.className = 'visually-hidden';
    hiddenElm.textContent = slug.replace(/-/g, ' ');

    linkTitle.classList.add('is-updated');

    linkTitle.appendChild(hiddenElm);
  })
}

function crossSellFunc() {
  const crossSellBlock = document.querySelector('essential-upsell-cross-sell-app-block');
  if (!crossSellBlock) return;

  const crossSellObserver = new MutationObserver(() => {
    const images = crossSellBlock.querySelectorAll('[data-essential-upsell-element="image"]');
    const productSliders = crossSellBlock.querySelectorAll('[data-essential-upsell-element="products"] div[role="group"][aria-hidden]');

    if(images.length > 0) updateCrossSellImageQuality(images);
    if(productSliders.length > 0) updateAttributes(productSliders);

    updateTitleName(crossSellBlock);
  });

  crossSellObserver.observe(crossSellBlock, {
    childList: true,
    subtree: true,
  });
}

crossSellFunc();
